import React from 'react';

import { Box, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

export default function AddAdultSeatButton({ onClick }) {
  return (
    <>
      <Box style={{ width: '25%' }}>
        <Box
          style={{
            borderRadius: '26px',
            border: '1px solid #707070',
            width: '39px',
            height: '39px',

            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton onClick={onClick}>
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
